import { Injectable } from '@angular/core';
import { DateService } from '@rd/core/services/date/date.service';

@Injectable()
export class AnzPointsExpiryService {
  constructor(private dateService: DateService) {}

  lastDayInExpiryYear(): Date {
    const lastDayOfYear = this.dateService.lastDayOfCurrentLocalYear();

    return this.dateService.dayjs(lastDayOfYear).toDate();
  }

  lastDayInExpiryYearStr(): string {
    return this.dateService
      .dayjs(this.lastDayInExpiryYear())
      .format('Do MMMM YYYY');
  }
}
